import React from 'react';
import Buttons from "./Buttons";

const TableGridHeader = (props) => (
    <div className="tableGridHeader">
        <div className="tableGridHeaderContent">
            <h2 className="tableGridHeaderTitle">{props.title}</h2>
            <div style={{height : "60px"}}>
                {props.resultCnt > 0 && (<Buttons dataCached={props.dataCached} canGeneratePDF={props.canGeneratePDF} rowCount={ props.resultCnt}/>
                ) }
            </div>

        </div>
        <div className="tableGridHeaderUnderline" />
    </div>
);


export default TableGridHeader;


// WEBPACK FOOTER //
// ./src/Components/TableGridHeader.js